/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Paging_RecordWithRecordPermission_ } from '../models/Paging_RecordWithRecordPermission_';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class TeamRecordService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Get Team Records
   * @param slug
   * @param id
   * @param query 검색 키워드
   * @param userId 대화에 참여한 user의 id
   * @param labelIds 레이블 id 리스트
   * @param labelFilterCondition 레이블 필터링 조건
   * @param order 레코드 정렬 기준 (내림차순)
   * @param ownerUserIds 레코드 소유자 id 리스트
   * @param recordSources 레코드 소스 리스트
   * @param startDate 시작 날짜 (YYYY-MM-DD)
   * @param endDate 끝 날짜 (YYYY-MM-DD)
   * @param nextToken pagination token
   * @returns Paging_RecordWithRecordPermission_ Successful Response
   * @throws ApiError
   */
  public getTeamRecordsV1WorkspacesSlugTeamsIdRecordsGet(
    slug: string,
    id: number,
    query?: string | null,
    userId?: number | null,
    labelIds?: Array<number> | null,
    labelFilterCondition: 'and' | 'or' = 'and',
    order: 'id' | 'rec_date' = 'id',
    ownerUserIds?: Array<number> | null,
    recordSources?: Array<
      | 'zoom'
      | 'google_meet'
      | 'teams_meet'
      | 'phone_call'
      | 'voice_recorder'
      | 'screen_recorder'
      | 'manual_upload'
    > | null,
    startDate?: string | null,
    endDate?: string | null,
    nextToken?: string | null
  ): CancelablePromise<Paging_RecordWithRecordPermission_> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/workspaces/{slug}/teams/{id}/records',
      path: {
        slug: slug,
        id: id,
      },
      query: {
        query: query,
        user_id: userId,
        label_ids: labelIds,
        label_filter_condition: labelFilterCondition,
        order: order,
        owner_user_ids: ownerUserIds,
        record_sources: recordSources,
        start_date: startDate,
        end_date: endDate,
        next_token: nextToken,
      },
      errors: {
        401: `Unauthorized`,
        403: `Insufficient privileges`,
        422: `Validation Error`,
      },
    });
  }
}
